// extracted by mini-css-extract-plugin
export var menuIcon = "_t3-0";
export var menuIconInline = "_t3-1";